'use strict';

var _regeneratorRuntime = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var errCode = require('err-code');

var CID = require('cids');
/**
 * Transform one of:
 *
 * ```ts
 * CID
 * String
 * { cid: CID recursive, metadata }
 * { path: String recursive, metadata }
 * Iterable<CID>
 * Iterable<String>
 * Iterable<{ cid: CID recursive, metadata }>
 * Iterable<{ path: String recursive, metadata }>
 * AsyncIterable<CID>
 * AsyncIterable<String>
 * AsyncIterable<{ cid: CID recursive, metadata }>
 * AsyncIterable<{ path: String recursive, metadata }>
 * ```
 * Into:
 *
 * ```ts
 * AsyncIterable<{ path: CID|String, recursive:boolean, metadata }>
 * ```
 *
 * @param {Source} input
 * @returns {AsyncIterable<Pin>}
 */
// eslint-disable-next-line complexity


module.exports = /*#__PURE__*/function () {
  var _normaliseInput = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
    var iterator, first, _iterator3, _step3, cid, _iterator4, _step4, obj, _iterator5, _first, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, _cid, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, _obj;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(input === null || input === undefined)) {
              _context.next = 2;
              break;
            }

            throw errCode(new Error("Unexpected input: ".concat(input)), 'ERR_UNEXPECTED_INPUT');

          case 2:
            if (!CID.isCID(input)) {
              _context.next = 6;
              break;
            }

            _context.next = 5;
            return toPin({
              cid: input
            });

          case 5:
            return _context.abrupt("return");

          case 6:
            if (!(input instanceof String || typeof input === 'string')) {
              _context.next = 10;
              break;
            }

            _context.next = 9;
            return toPin({
              path: input
            });

          case 9:
            return _context.abrupt("return");

          case 10:
            if (!(input.cid != null || input.path != null)) {
              _context.next = 14;
              break;
            }

            _context.next = 13;
            return toPin(input);

          case 13:
            return _context.abrupt("return", _context.sent);

          case 14:
            if (!input[Symbol.iterator]) {
              _context.next = 62;
              break;
            }

            iterator = input[Symbol.iterator]();
            first = iterator.next();

            if (!first.done) {
              _context.next = 19;
              break;
            }

            return _context.abrupt("return", iterator);

          case 19:
            if (!(CID.isCID(first.value) || first.value instanceof String || typeof first.value === 'string')) {
              _context.next = 40;
              break;
            }

            _context.next = 22;
            return toPin({
              cid: first.value
            });

          case 22:
            _iterator3 = _createForOfIteratorHelper(iterator);
            _context.prev = 23;

            _iterator3.s();

          case 25:
            if ((_step3 = _iterator3.n()).done) {
              _context.next = 31;
              break;
            }

            cid = _step3.value;
            _context.next = 29;
            return toPin({
              cid: cid
            });

          case 29:
            _context.next = 25;
            break;

          case 31:
            _context.next = 36;
            break;

          case 33:
            _context.prev = 33;
            _context.t0 = _context["catch"](23);

            _iterator3.e(_context.t0);

          case 36:
            _context.prev = 36;

            _iterator3.f();

            return _context.finish(36);

          case 39:
            return _context.abrupt("return");

          case 40:
            if (!(first.value.cid != null || first.value.path != null)) {
              _context.next = 61;
              break;
            }

            _context.next = 43;
            return toPin(first.value);

          case 43:
            _iterator4 = _createForOfIteratorHelper(iterator);
            _context.prev = 44;

            _iterator4.s();

          case 46:
            if ((_step4 = _iterator4.n()).done) {
              _context.next = 52;
              break;
            }

            obj = _step4.value;
            _context.next = 50;
            return toPin(obj);

          case 50:
            _context.next = 46;
            break;

          case 52:
            _context.next = 57;
            break;

          case 54:
            _context.prev = 54;
            _context.t1 = _context["catch"](44);

            _iterator4.e(_context.t1);

          case 57:
            _context.prev = 57;

            _iterator4.f();

            return _context.finish(57);

          case 60:
            return _context.abrupt("return");

          case 61:
            throw errCode(new Error('Unexpected input: ' + typeof input), 'ERR_UNEXPECTED_INPUT');

          case 62:
            if (!input[Symbol.asyncIterator]) {
              _context.next = 146;
              break;
            }

            _iterator5 = input[Symbol.asyncIterator]();
            _context.next = 66;
            return _awaitAsyncGenerator(_iterator5.next());

          case 66:
            _first = _context.sent;

            if (!_first.done) {
              _context.next = 69;
              break;
            }

            return _context.abrupt("return", _iterator5);

          case 69:
            if (!(CID.isCID(_first.value) || _first.value instanceof String || typeof _first.value === 'string')) {
              _context.next = 107;
              break;
            }

            _context.next = 72;
            return toPin({
              cid: _first.value
            });

          case 72:
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context.prev = 74;
            _iterator = _asyncIterator(_iterator5);

          case 76:
            _context.next = 78;
            return _awaitAsyncGenerator(_iterator.next());

          case 78:
            _step = _context.sent;
            _iteratorNormalCompletion = _step.done;
            _context.next = 82;
            return _awaitAsyncGenerator(_step.value);

          case 82:
            _value = _context.sent;

            if (_iteratorNormalCompletion) {
              _context.next = 90;
              break;
            }

            _cid = _value;
            _context.next = 87;
            return toPin({
              cid: _cid
            });

          case 87:
            _iteratorNormalCompletion = true;
            _context.next = 76;
            break;

          case 90:
            _context.next = 96;
            break;

          case 92:
            _context.prev = 92;
            _context.t2 = _context["catch"](74);
            _didIteratorError = true;
            _iteratorError = _context.t2;

          case 96:
            _context.prev = 96;
            _context.prev = 97;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context.next = 101;
              break;
            }

            _context.next = 101;
            return _awaitAsyncGenerator(_iterator.return());

          case 101:
            _context.prev = 101;

            if (!_didIteratorError) {
              _context.next = 104;
              break;
            }

            throw _iteratorError;

          case 104:
            return _context.finish(101);

          case 105:
            return _context.finish(96);

          case 106:
            return _context.abrupt("return");

          case 107:
            if (!(_first.value.cid != null || _first.value.path != null)) {
              _context.next = 145;
              break;
            }

            _context.next = 110;
            return toPin(_first.value);

          case 110:
            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _context.prev = 112;
            _iterator2 = _asyncIterator(_iterator5);

          case 114:
            _context.next = 116;
            return _awaitAsyncGenerator(_iterator2.next());

          case 116:
            _step2 = _context.sent;
            _iteratorNormalCompletion2 = _step2.done;
            _context.next = 120;
            return _awaitAsyncGenerator(_step2.value);

          case 120:
            _value2 = _context.sent;

            if (_iteratorNormalCompletion2) {
              _context.next = 128;
              break;
            }

            _obj = _value2;
            _context.next = 125;
            return toPin(_obj);

          case 125:
            _iteratorNormalCompletion2 = true;
            _context.next = 114;
            break;

          case 128:
            _context.next = 134;
            break;

          case 130:
            _context.prev = 130;
            _context.t3 = _context["catch"](112);
            _didIteratorError2 = true;
            _iteratorError2 = _context.t3;

          case 134:
            _context.prev = 134;
            _context.prev = 135;

            if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
              _context.next = 139;
              break;
            }

            _context.next = 139;
            return _awaitAsyncGenerator(_iterator2.return());

          case 139:
            _context.prev = 139;

            if (!_didIteratorError2) {
              _context.next = 142;
              break;
            }

            throw _iteratorError2;

          case 142:
            return _context.finish(139);

          case 143:
            return _context.finish(134);

          case 144:
            return _context.abrupt("return");

          case 145:
            throw errCode(new Error('Unexpected input: ' + typeof input), 'ERR_UNEXPECTED_INPUT');

          case 146:
            throw errCode(new Error('Unexpected input: ' + typeof input), 'ERR_UNEXPECTED_INPUT');

          case 147:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[23, 33, 36, 39], [44, 54, 57, 60], [74, 92, 96, 106], [97,, 101, 105], [112, 130, 134, 144], [135,, 139, 143]]);
  }));

  function normaliseInput(_x) {
    return _normaliseInput.apply(this, arguments);
  }

  return normaliseInput;
}();
/**
 * @param {ToPinWithPath|ToPinWithCID} input
 * @returns {Pin}
 */


function toPin(input) {
  var pin = {
    path: input.path == null ? input.cid : "".concat(input.path),
    recursive: input.recursive !== false
  };

  if (input.metadata != null) {
    pin.metadata = input.metadata;
  }

  return pin;
}
/**
 * @typedef {Object} ToPinWithPath
 * @property {string | InstanceType<typeof window.String> | CID} path
 * @property {undefined} [cid]
 * @property {boolean} [recursive]
 * @property {any} [metadata]
 *
 * @typedef {Object} ToPinWithCID
 * @property {undefined} [path]
 * @property {CID} cid
 * @property {boolean} [recursive]
 * @property {any} [metadata]
 *
 * @typedef {CID|string|InstanceType<typeof window.String>|ToPinWithPath|ToPinWithPath} ToPin
 * @typedef {ToPin|Iterable<ToPin>|AsyncIterable<ToPin>} Source
 *
 * @typedef {Object} Pin
 * @property {string|CID} path
 * @property {boolean} recursive
 * @property {any} [metadata]
 */